import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { StripeFacade } from 'gb-dashboard/shared/data-access-stripe'
import * as StripeActions from 'libs/gb-dashboard/shared/data-access-stripe/src/lib/+state/stripe.actions'
import { GbStripeService } from 'libs/gb-dashboard/shared/data-access-stripe/src/lib/gb-stripe.service'

@UntilDestroy()
@Component({
  selector: 'gb-add-card',
  templateUrl: './gb-add-card.component.html',
  styleUrls: ['./gb-add-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbAddCardComponent implements OnInit {
  @Input({ required: true }) profileUuid!: string

  constructor(
    private stripeFacade: StripeFacade,
    private gbStripeService: GbStripeService,
  ) {}

  ngOnInit() {
    this.stripeFacade.dispatch(StripeActions.prepareForNewCardSetup({ profileUuid: this.profileUuid }))
    this.mountPaymentElement()
  }

  mountPaymentElement() {
    this.gbStripeService.paymentElement$.pipe(untilDestroyed(this)).subscribe((paymentElement) => {
      if (!paymentElement) return

      paymentElement.mount('#stripe-card-details-element')
    })
  }
}
